module.exports = __webpack_public_path__ + "img/示例图_1.aed57985.png";